import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    boxContainer: {
        width: "100%",
    },
    boxContainerSeparator: {
        width: "100%",
        paddingBottom: "30px",
        borderBottom: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
    },
    formContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: theme.spacing(6),
        padding: "20px 30px 0",
    },
    formLabel: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root.Mui-focused": {
            color: theme.palette.primary.dark,
        },
    },
    checkbox: {
        "&.MuiCheckbox-root": {
            color: theme.palette.corporateBO.checkbox,
            "&.Mui-checked": {
                color: theme.palette.info.main,
            },
        },
    },
    textField: {
        width: "100%",
        height: 56,
        "& .MuiOutlinedInput-root": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Open Sans",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.main,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            background: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            borderBottom: "1px solid rgba(193, 200, 218, 1)",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Open Sans",
            paddingBottom: "5px",
        },
    },
    buttonsContainer: {
        width: "100%",
        borderTop: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
        padding: "15px 30px",
        display: "flex",
        justifyContent: "flex-end",
    },
    addButton: {
        "&.MuiButton-root": {
            background: theme.palette.info.main,
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            color: theme.palette.primary.main,
            marginLeft: "15px",
        },
        "&.MuiButton-root:hover": {
            background: theme.palette.info.main,
        },
    },
    cancelButton: {
        "&.MuiButtonBase-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            color: theme.palette.primary.dark,
        },
    },
    select: {
        textAlign: "left",
    },
    switch: {
        "&.MuiSwitch-root .MuiButtonBase-root .MuiSwitch-thumb": {
            background: theme.palette.primary.dark,
        },
        "&.MuiSwitch-root .Mui-checked .MuiSwitch-thumb": {
            background: theme.palette.info.main,
        },
        "&.MuiSwitch-root .MuiSwitch-track": {
            background: theme.palette.corporateBO.checkboxTrack,
        },
        "&.MuiSwitch-root .Mui-checked+ .MuiSwitch-track": {
            background: theme.palette.corporateBO.checkboxTrackChecked,
        },
    },
    switchLabel: {
        "&.MuiFormControlLabel-root": {
            width: "100%",
            justifyContent: "flex-end",
            margin: 0,
        },
        "&.MuiFormControlLabel-root .MuiTypography-root": {
            fontFamily: "Open Sans",
            fontWeight: 400,
            fontSize: "14px",
            color: theme.palette.text.secondary,
        },
    },
}));
